__turbopack_context__.v({
  "partSelectContainer": "_4_mXBG_partSelectContainer",
});
